<template>
    <div class="setting-app">
        <div class="top">
            <img src="@static/images/setting/app.png" alt />
            <div class="topword">
                <p class="topTitle">APP设置</p>
                <P class="topDesc">您可根据您的实际情况自定义配置凤栖云服APP首页布局、首页工具栏、以及底部导航栏。</P>
            </div>
            <span class="reset-module" @click="resetModule">恢复默认设置</span>
        </div>
        <div class="body">
            <div class="info-text">操作说明：模块间上下拖动可进行排序；工具栏以及底部导航栏，可点击进行编辑修改。修改/删除后需点击页面上的保存方可生效。</div>
            <div class="content">
                <div class="left-box">
                    <!--顶部导航-->
                    <div class="phone-head">
                        <img src="@static/images/setting/top.png" alt="">
                        <div class="nav-box">
                            <template v-for="item in viewport">
                                <p v-if="item.moduleCode==MODULE[1]" :key="item.id">
                                    <template v-for="topbar in item.children">
                                        <img :src="topbar.img|settingImage" alt="" :key="topbar.id">
                                    </template>
                                </p>
                            </template>
                            <p v-if="list[activeFooterTab]&&list[activeFooterTab].moduleCode!=='PRODUCT_NAVIGATION'" class="title">
                                {{list[activeFooterTab]&&list[activeFooterTab].title}}
                            </p>
                            <p v-else>
                                <span>我的产品库</span>
                                <span>全部产品库</span>
                            </p>
                        </div>
                    </div>
                    <div class="list">
                        <div class="viewport-module" v-if="list[activeFooterTab]&&list[activeFooterTab].userEffectPicture==1">
                            <img :src="list[activeFooterTab].effectPicture" class="page-img">
                        </div>
                        <iframe v-else-if="list[activeFooterTab]&&list[activeFooterTab].url" :src="list[activeFooterTab].url" frameborder="0"></iframe>
                        <draggable v-else class="viewport-module" :list="viewport" ghost-class="ghost" :options="{draggable: '.list-item',group:'t1'}"
                                :disabled="list[activeFooterTab]&&!hasEdit(2)||!list[activeFooterTab]||list[activeFooterTab].moduleCode=='MY_NAVIGATION'">
                            <template v-for="(item,moduleIndex) in viewport">
                                <!--工具栏-->
                                <div class="tools-box list-item" v-if="item.moduleCode==MODULE[0]" :key="item.id" v-show="item.children&&item.children.length>0">
                                    <div class="item" v-for="toolbar in item.children" :key="toolbar.id">
                                        <img :src="toolbar.img|settingImage">
                                        <span class="name">{{toolbar.name}}</span>
                                    </div>
                                    <p class="box-del" v-if="list[activeFooterTab]&&Number(item.isDelete)===1&&hasEdit(2)"><i class="icon-shanchu" @click="proxyOperation({index:moduleIndex})"></i></p>
                                </div>
                                <div v-else-if="item.moduleCode===MODULE[2]" v-show="item.children&&item.children.length>0" class="center-config list-item" :key="item.id">
                                    <ul>
                                        <li v-for="personConfig in item.children" :key="personConfig.id">
                                            <p>
                                                <img :src="personConfig.img|settingImage">
                                                <span>{{personConfig.name}}</span>
                                            </p>
                                            <i class="icon-youjiantou"></i>
                                        </li>
                                    </ul>
                                    <p class="box-del" v-if="list[activeFooterTab]&&Number(item.isDelete)===1&&hasEdit(2)"><i class="icon-shanchu" @click="proxyOperation({index:moduleIndex})"></i></p>
                                </div>
                                <!--其他模块 广告模块无数据不显示-->
                                <div v-else-if="item.moduleCode!==MODULE[1]" v-show="!(item.moduleCode=='INDEX_AD'&&(!item.children||item.children.length==0))" class="list-item" :key="item.id" :class="{'hide-margin':item.moduleCode=='BANNER'}">
                                    <img :src="item.effectPicture" alt="" :style="item.userEffectPicture|filtterExtendParams">
                                    <p class="box-del" v-if="list[activeFooterTab]&&hasEdit(2)&&Number(item.isDelete)===1">
                                        <i class="icon-shanchu" @click="proxyOperation({index:moduleIndex})"></i>
                                    </p>
                                </div>
                            </template>
                        </draggable>
                        <!--底部Tab-->
                        <ul class="phone-bottom footer-box">
                            <li v-for="(item,index) in list" :key="item.id" @click="choseTabView(index)">
                                <img :src="item[activeFooterTab===index?'img2':'img']|settingImage">
                                <span class="name" :class="{'active':activeFooterTab===index}">{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <p class="viewport-add" v-if="list[activeFooterTab]&&list[activeFooterTab].isAdd&&hasEdit(2)&&!hasAddByCount(viewport,list[activeFooterTab].limitCount)"
                        @click="openToolsForm('secondModule')">添加模块</p>
                </div>
                <div class="right-box">
                    <div class="box-content">
                        <template v-for="item in viewport">
                            <!--工具栏-->
                            <div class="tools-box" :key="item.id" v-if="MODULE.includes(item.moduleCode)&&hasEdit(2)&&item.isEdit">
                                <p class="box-title ignore-elements">{{item.name}}</p>
                                <draggable :list="item.children" :options="{draggable: '.item',filter: '.ignore-elements'}" class="drag-box">
                                    <div class="item" v-for="(toolbar,index) in item.children" :key="toolbar.id" :class="{'bg':item.moduleCode=='TOP_NAVIGATION'}">
                                        <img :src="toolbar.img|settingImage">
                                        <span class="name">{{toolbar.name}}</span>
                                        <div class="btn-list">
                                            <i class="icon-bianji" @click="moduleOperation(1,item,index)"></i>
<!--                                            <i class="icon-shanchu" @click="moduleOperation(2,item,index)" v-if="Number(toolbar.isDelete)===1"></i>-->
                                            <i class="icon-shanchu" @click="proxyOperation({type:2,item,index})" v-if="Number(toolbar.isDelete)===1"></i>
                                        </div>
                                    </div>
                                    <div class="add-btn ignore-elements" @click="openToolsForm(`${item.name}-add`)" v-if="item.isAdd&&item.limitCount>item.children.length">
                                        <i class="icon-xinzeng1"></i>
                                        <span>添加</span>
                                    </div>
                                </draggable>
                            </div>
                        </template>
                        <div class="tools-box" v-if="hasEdit(1)">
                            <p class="box-title ignore-elements">底部导航</p>
                            <draggable :list="list" :options="{'draggable':'.item',filter: '.ignore-elements'}" class="drag-box" @change="bottomNavSort">
                                <div class="item" v-for="(footerTab,index) in list" :key="`${footerTab.name}-index`">
                                    <img :src="footerTab.img|settingImage">
                                    <span class="name">{{footerTab.name}}</span>
                                    <div class="btn-list">
                                        <i class="icon-bianji" @click.stop.prevent="moduleOperation(3,footerTab,index)"></i>
<!--                                        <i class="icon-shanchu" @click.stop.prevent="moduleOperation(4,footerTab,index)" v-if="Number(footerTab.isDelete)===1"></i>-->
                                        <i class="icon-shanchu" @click.stop.prevent="proxyOperation({type:4,item:footerTab,index})" v-if="Number(footerTab.isDelete)===1"></i>
                                    </div>
                                </div>
                                <div class="add-btn ignore-elements" @click="openToolsForm('tab')" v-if="footerBar.isAdd&&footerBar.limitCount>list.length">
                                    <i class="icon-xinzeng1"></i>
                                    <span>添加</span>
                                </div>
                            </draggable>
                        </div>
                    </div>
                    <div class="submit-box" v-if="hasEdit(1)">
                        <el-button type="primary" @click="save()">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="toolsModalVisible" :title="activeRightBox.moduleCode===MODULE[1]?`添加${activeRightBox.name}`:`编辑${activeRightBox.name}`"
            class="isConfig" :class="{'isAdd':isAdd&&activeRightBox.name!==MODULE[1]}" width='700px' @close="clearForm" :close-on-click-modal="false">
            <el-tabs v-model="activeName" v-if="isAdd">
                <el-tab-pane :label="`系统${activeRightBox.name}`" name="1"></el-tab-pane>
                <el-tab-pane :label="`自定义${activeRightBox.name}`" name="2"></el-tab-pane>
            </el-tabs>
            <div class="el-icon el-icon-close add-modal-close" v-if="isAdd" @click="toolsModalVisible=false"></div>
            <div class="sys-table" v-if="activeName==1&&isAdd" v-loading="loading">
                <div class="srcoll-sys-module">
                    <template v-for="(item,index) in sysConfig.list">
                        <div class="table-row" :key="item.id" v-if="index<10*sysConfig.currentPage&&index>=10*(sysConfig.currentPage-1)">
                            <div class="table-item" >
                                <img :src="item.img|settingImage" :class="{'bg':activeRightBox.moduleCode=='TOP_NAVIGATION'}">
                                <span class="name">{{item.name}}</span>
                            </div>
                            <div class="table-item">{{item.description}}</div>
                            <div class="table-item">
                                <div :class="hasAddFn(item.id,viewport)|sysConfigText(2)" @click="addModule(1,item)">{{hasAddFn(item.id,viewport)|sysConfigText}}</div>
                            </div>
                        </div>
                    </template>
                    <div class="empty-box" v-if="!sysConfig.list||sysConfig.list.length==0">
                        <img src="@static/images/no.png">
                        <div class="text">暂无数据</div>
                    </div>
                </div>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :hide-on-single-page="true"
                    @current-change="changeSysConfigPage"
                    :total="sysConfig.list.length">
                </el-pagination>
            </div>
            <el-form :model="form" label-width="90px" ref='form1' :rules="rules1" label-position="right" v-else>
                <el-form-item label="工具名称" prop="name">
                    <el-input placeholder="请输入详细内容" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="工具链接" prop="url" v-if="form.isCustom==1||isAdd">
                    <el-input placeholder="请输入链接地址http://或https://" v-model="form.url"></el-input>
                </el-form-item>
                <el-form-item label="工具图标" prop="img">
                    <el-upload
                        class="uplaod-box"
                        ref="upload"
                        @click.native="uploadkey='img'"
                        :action="api_root+'/resmgr/upload'"
                        :show-file-list="false"
                        :on-success="uploadSuccess"
                        :before-upload="beforeUpload"
                        :on-error="uploadError">
                        <div class="upload-btn">
                            <img :src="form.img" v-if="form.img" :class="{'bg':activeRightBox.moduleCode=='TOP_NAVIGATION'}">
                            <i class="el-icon-upload" v-else></i>
                        </div>
                    </el-upload>
                    <div class="upload-text">上传的图片最大不超过500kb，仅限上传jpg/jpeg/gif/bmp/png格式，建议尺寸为138*138</div>
                </el-form-item>
            </el-form>
            <div class="submit-box" v-if="Number(activeName)!==1&&isAdd||!isAdd">
                <el-button type="primary" @click="toolsModalVisible=false" plain>取消</el-button>
                <el-button type="primary" @click="submitTools(1)">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="navModalVisible" title="编辑底部导航" class="isConfig" :class="{'isAdd':isAdd}"
                width='700px' @close="clearForm" :close-on-click-modal="false">
            <el-tabs v-model="activeName" v-if="isAdd">
                <el-tab-pane label="系统导航栏" name="1"></el-tab-pane>
                <el-tab-pane label="自定义导航栏" name="2"></el-tab-pane>
            </el-tabs>
            <div class="el-icon el-icon-close add-modal-close" v-if="isAdd" @click="navModalVisible=false"></div>
            <div class="sys-table" v-if="activeName==1&&isAdd" v-loading="loading">
                <div class="table-row" v-for="item in sysConfig.list" :key="item.id">
                    <div class="table-item">
                        <img :src="item.img|settingImage">
                        <span class="name">{{item.name}}</span>
                    </div>
                    <div class="table-item">{{item.description}}</div>
                    <div class="table-item">
                        <div :class="hasAddFn(item.id,list)|sysConfigText(2)" @click="addModule(2,item)">
                            {{hasAddFn(item.id,list)|sysConfigText(3)}}
                        </div>
                    </div>
                </div>
            </div>
            <el-form :model="form" label-width="90px" ref='form2' :rules="rules2" label-position="right" v-else>
                <el-form-item label="导航名称" prop="name">
                    <el-input placeholder="请输入详细内容" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="页面标题" prop="title" v-if="form.name!=='产品'">
                    <el-input placeholder="请输入详细内容" v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="导航链接" prop="url" v-if="isAdd||form.isCustom==1">
                    <el-input placeholder="请输入链接地址http://或https://" v-model="form.url"></el-input>
                </el-form-item>
                <el-form-item label="导航图标" prop="img2">
                    <el-upload
                        class="uplaod-box"
                        ref="upload"
                        @click.native="uploadkey='img'"
                        :action="api_root+'/resmgr/upload'"
                        :show-file-list="false"
                        :on-success="uploadSuccess"
                        :before-upload="beforeUpload"
                        :on-error="uploadError">
                        <div class="upload-btn">
                            <img :src="form.img" v-if="form.img">
                            <i class="el-icon-upload" v-else></i>
                        </div>
                        <div class="upload-text2">未选中状态</div>
                    </el-upload>
                    <el-upload
                        class="uplaod-box"
                        ref="upload"
                        @click.native="uploadkey='img2'"
                        :action="api_root+'/resmgr/upload'"
                        :show-file-list="false"
                        :on-success="uploadSuccess"
                        :before-upload="beforeUpload"
                        :on-error="uploadError">
                        <div class="upload-btn">
                            <img :src="form.img2" v-if="form.img2">
                            <i class="el-icon-upload" v-else></i>
                        </div>
                        <div class="upload-text2">选中状态</div>
                    </el-upload>
                    <div class="icon-list">
                        <img :src="activeIcon==i?item.url.replace('/icon/','/icon/a'):item.url" v-for="(item,i) in iconList" :key="i"
                                :class="{'active':activeIcon==i}" @click="selectIcon(item,i)">
                    </div>
                    <div class="upload-text" style="width:auto">可直接选择上方的系统导航图标，也可点击上传导航图标，图标尺寸建议66*66</div>
                </el-form-item>
            </el-form>
            <div class="submit-box" v-if="Number(activeName)!==1&&isAdd||!isAdd">
                <el-button type="primary" @click="navModalVisible=false" plain>取消</el-button>
                <el-button type="primary" @click="submitTools(2)">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modalVisible" title="添加模块" class="isConfig" :class="{'isAdd':!isAdd}" width='700px'>
            <!--<el-tabs v-model="activeName" v-if="isAdd">
                <el-tab-pane label="系统导航栏" name="1"></el-tab-pane>
                <el-tab-pane label="自定义导航栏" name="2"></el-tab-pane>
            </el-tabs>-->
            <div class="sys-table" v-loading="loading">
                <div class="table-row" v-for="item in sysConfig.list" :key="item.id">
                    <div class="table-item">
                        <img :src="item.img|settingImage">
                        <span class="name">{{item.name}}</span>
                    </div>
                    <div class="table-item">{{item.description}}</div>
                    <div class="table-item">
                        <div :class="(hasAddFn(item.id,viewport)||hasAddByCount(viewport,list[activeFooterTab].limitCount))|sysConfigText(2)"
                            @click="addModule(3,item)">
                            <template v-if="hasAddFn(item.id,viewport)">
                                已添加
                            </template>
                            <template v-else-if="hasAddByCount(viewport,list[activeFooterTab].limitCount)">
                                已超出数量限制
                            </template>
                            <template v-else>
                                添加模块
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="deleteVisible.state"
            width="30%">
            <span>{{deleteVisible.description}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="proxyOperation()">取 消</el-button>
                <el-button type="primary" @click="proxyOperation('save')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
// https://sortablejs.github.io/Vue.Draggable/#/simple
import draggable from "vuedraggable";
import {ruleTool} from '@/api/mixins';
import common from '@/api/common';
import config from './app.config'
import Swiper from "swiper"
import 'swiper/dist/css/swiper.css'

//当前实例组件
export default {
    mixins: [ruleTool],
    data:()=>(config),
    components: { draggable },
    created() {
        this.api_root = this.$config.api_root;
        this.getData();
        // 避免拖拽打开新窗口
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    },
    methods: {
        bottomNavSort(e) {
            console.log(e)
            var oldI = e.moved.oldIndex;
            var curI = this.activeFooterTab;
            var newI = e.moved.newIndex;
            if(oldI == curI){
                this.activeFooterTab = e.moved.newIndex;
            }else if(oldI<curI && newI>=curI){
                this.activeFooterTab--;
            }else if(oldI>curI && newI<=curI){
                this.activeFooterTab++
            }
            console.log(this.activeFooterTab,e.moved.newIndex,e.moved.oldIndex)
        },
        /**
         * 添加工具栏弹窗中系统模块分页
         */
        changeSysConfigPage(val){
            this.$set(this.sysConfig,'currentPage',val)
        },
        resetModule(){
            this.$http({
                url:'/master/module/restoreDefault',
                type:'put',
                params:{}
            }).then((res)=> {
                this.$message.success("操作成功");
                this.getData()
            })
        },
        /**
         * 清空自定义模块表单
         */
        clearForm(){
            for(let item in this.form){
                this.$set(this.form,item,'')
            }
            this.activeName = "";
            this.activeIcon = -1
        },
        /**
         * 选择二级容器-底部tab对应的三级容器
         * @param item
         */
        choseTabView(index){
            this.save(2)
            this.activeFooterTab=index;
            const viewport = this.list[this.activeFooterTab].children;
            if(viewport && viewport.length){
                this.viewport=JSON.parse(JSON.stringify(viewport));
            }else{
                this.viewport = [];
            }
            /*if(this.dataChanged){
                this.deleteVisible.state='saveDialog'
                this.deleteVisible.description=this.deleteVisible.txtTwo
                this.deleteVisible.delIndex={index}
            }else{//初始化容器数据
                this.activeFooterTab=index
                this.viewport=JSON.parse(JSON.stringify(this.list[this.activeFooterTab].children))
            }*/
        },
        getData(){
            this.$http({
                url: '/master/module/queryMechanModule',
                type: 'put',
                params:{}
            }).then((data)=> {
                let moduleList = JSON.parse(JSON.stringify(data.data[0]));
                this.list=JSON.parse(JSON.stringify(moduleList.children))
                this.viewport=JSON.parse(JSON.stringify(this.list[this.activeFooterTab].children))
                this.footerBar = Object.assign({},this.footerBar,{
                    id:moduleList.id,
                    level:moduleList.level,
                    name:moduleList.name,
                    isAdd:moduleList.isAdd,
                    isEdit:moduleList.isEdit,
                    limitCount:moduleList.limitCount
                    // isSort:!moduleList.isSort?0:1
                })
            });
        },
        /**
         * 获取系统工具栏、导航栏模块
         * @param item
         */
        getSysModule(item){
            if(this.sysConfig.module===this.activeRightBox.id){
                this.loading=false
                return
            }else{
                this.sysConfig.list=[]
            }
            this.$http({
                url:'/master/module/queryDefaultChildModule',
                type:'put',
                params:{
                    parentId:item.id,
                    level:item.level
                }
            }).then((data)=> {
                this.loading=false
                this.sysConfig=Object.assign({},this.sysConfig,{
                    module:this.activeRightBox.id,
                    list:[].concat(data.data)
                })
            });
        },
        /**
         * 操作模块配置项
         * @param type 1=工具栏新增，2=底部导航新增，3=二级容器添加模块，edit-1=工具栏编辑，edit-2=底部导航编辑
         * @param item
         */
        addModule(type,item){
            let copyCell=JSON.parse(JSON.stringify(item))//执行拷贝防止污染sysConfig对象中的列表数据
            // this.dataChanged=true
            if(type===3){
                let str=JSON.stringify(this.viewport)
                if(str.includes(item.id)){
                    this.$message.error("模块已添加");
                    return;
                }
                if(this.list[this.activeFooterTab].limitCount<=this.viewport.length){
                    this.$message.error("已达到模块数量限制");
                    return;
                }
                this.viewport.splice(item.orderNum,0,copyCell)
                return
            }
            let result=this.viewport.filter(child=>{
                return child.name===this.activeRightBox.name
            })
            if([2,"edit-2"].includes(type)){
                result=[].concat({
                    children:this.list,
                    id:this.footerBar.id,
                    level:this.footerBar.level,
                })
            }
            if([1,2].includes(type)){
                if(!this.hasAddFn(copyCell.id, result[0].children)){
                    result[0].children.push(copyCell)
                }else{
                    this.$message.error("模块已添加");
                    return;
                }
                /*this.saveModule({
                    params:{
                        parentId:result[0].id,
                        level:result[0].level,
                        data:result[0].children
                    }
                })*/
                // this.$set(item,'isAdded',1+'')
                this.navModalVisible=false
                this.toolsModalVisible=false
            }else{
                let cell=result[0].children.splice(this.activeRightBox.index,1)
                result[0].children.splice(this.activeRightBox.index,0,Object.assign({},cell[0],this.form,{isModify:1}))
                /*this.saveModule({
                    params:{
                        parentId:result[0].id,
                        level:result[0].level,
                        data:result[0].children
                    }
                })*/
            }
        },
        proxyOperation(type='init'){
            let del=JSON.parse(JSON.stringify(this.deleteVisible.delIndex))
            if(type==='init'){
                /*if(this.deleteVisible.state!=='delDialog'){//保存弹窗的取消事件
                    this.dataChanged=false
                    this.choseTabView(del.index)
                }*/
                this.deleteVisible=Object.assign({},this.deleteVisible,{
                    state:false,
                    description:'',
                    delIndex:Object.create(null)
                })
            }else if(type==='save'){
                if(del.type){
                    this.moduleOperation(del.type,del.item,del.index)
                }else{
                    this.moduleOperation(2,'viewport',del.index)
                }
                /*if(this.deleteVisible.state==='delDialog'){//删除弹窗的确认事件
                    if(del.type){
                        this.moduleOperation(del.type,del.item,del.index)
                    }else{
                        this.moduleOperation(2,'viewport',del.index)
                    }
                }else{//保存弹窗的确认事件
                    this.save()
                    // this.dataChanged=false
                    // this.choseTabView(del.index)
                }*/
                this.proxyOperation()
            }else{
                const data = JSON.parse(JSON.stringify(type));
                if(data.type == 4&&this.activeFooterTab==data.index){//底部导航删除
                    this.$message.error('不可删除当前选中的导航');
                    return;
                }
                this.deleteVisible.delIndex=JSON.parse(JSON.stringify(type))
                this.deleteVisible.state=true
                this.deleteVisible.description=this.deleteVisible.txtOne
            }
        },
        /**
         * 模块配置项删除编辑操作
         * @param type 1=编辑，2=删除，3=底部导航编辑，4=底部导航删除
         * @param item 操作的当前项 特殊场景viewport=直接删除整个模块
         * @param index 操作项的下标
         */
        moduleOperation(type,item,index){
            if(item==='viewport'&&type===2){
                this.viewport.splice(index,1)
                // this.dataChanged=true
                return
            }
            let result=this.viewport.filter(child=>{
                return child.name===item.name
            })
            if([3,4].includes(type)){
                result=[].concat({
                    children:this.list,
                    id:this.footerBar.id,
                    level:this.footerBar.level,
                    name:this.footerBar.name
                })
            }
            if([2,4].includes(type)&&result.length>0){
                result[0].children.splice(index,1)
                // this.dataChanged=true
                /*this.saveModule({
                    params:{
                        parentId:result[0].id,
                        level:result[0].level,
                        data:result[0].children
                    }
                })*/
                if(this.activeFooterTab>=index&&type===4){//删除的底部导航整好是当前项，重新设置当前viewport
                    if(this.activeFooterTab>index){
                        this.activeFooterTab--
                        return
                    }
                    this.choseTabView(0)
                }
            }else{//编辑修改操作
                let editCell=result[0].children[index]
                console.log(this.form,editCell)
                this.form=Object.assign(this.form,{
                    name:editCell.name,
                    url:editCell.url,
                    img:editCell.img,
                    isCustom:editCell.isCustom,
                    img2:editCell.img2,
                    title:editCell.title
                })
                if(editCell.footerIcon){//判断是否为底部导航栏编辑且选择的静态图标
                    this.activeIcon=Number(editCell.footerIcon)
                }
                this.openToolsForm([3,4].includes(type)?'tabEdit':`${result[0].name}-edit`,index)
            }
            this.isAdd=false
        },
        saveModule({params}){
            this.$http({
                url:'/master/module/saveModule',
                type:'put',
                params
            }).then((data)=> {
                this.$message.success('保存成功');
                this.getData();
            });
        },
        itemClick(item) {
            this.activeRightBox=Object.assign(this.activeRightBox,{
                id:item.id,
                name:item.name
            })
        },
        selectIcon(item, i){
            this.activeIcon = i;
            this.$set(this.form,"img",this.$config.api_root+'/fxyf/'+item.url);
            this.$set(this.form,"img2",this.$config.api_root+'/fxyf/'+item.url.replace("/icon/","/icon/a"));
            // Promise.all([this.toBlob(item.url),this.toBlob(item.url.replace("/icon/","/icon/a"))]).then(res=>{
            //     this.$set(this.form,"img",res[0]);
            //     this.$set(this.form,"img2",res[1]);
            // })
        },
        toBlob(url){
            return new Promise((resolved,rejected)=>{
                let image = new Image();
                image.onload = function() {
                    let canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    let context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, image.width, image.height);
                    resolved(canvas.toDataURL("image/png")) //得到图片的base64编码数据
                };
                image.src = url;
            })
        },
        /**
         * 打开Dialog弹窗
         * @param type tool-add=工具栏新增，tool-edit=工具栏编辑，tab=底部导航新增，tabEdit=底部导航编辑，secondModule=二级容器新增模块
         * @param index 编辑时必传
         */
        openToolsForm(type,index=0) {
            let toolArr=[]
            this.activeName="1"
            this.loading=true
            if(['tabEdit','tab'].includes(type)){
                toolArr=[].concat(this.footerBar)
                this.navModalVisible = true;
            }else if(type==='secondModule'){
                this.modalVisible=true;
                toolArr=[].concat(this.list[this.activeFooterTab])
            }else{
                this.toolsModalVisible = true;
                this.$set(this.sysConfig,'currentPage',1)
                toolArr=this.viewport.filter(item=>{
                    return item.name===type.split('-')[0]
                })
            }
            this.activeRightBox=Object.assign(this.activeRightBox,{
                id:toolArr[0].id,
                moduleCode:toolArr[0].moduleCode,
                name:toolArr[0].name,
                level:toolArr[0].level,
                index
            })
            if(type==='tab'||type.includes('add')||type==='secondModule'){
                /*if(type.includes('add')&&toolArr[0].limitCount<=toolArr[0].children.length||(type==='tab'&&toolArr[0].limitCount<=this.list.length)){
                    this.toolsModalVisible = false;
                    this.navModalVisible = false;
                    this.$message({
                        message:'已到上限'
                    })
                    return
                }*/
                this.getSysModule(toolArr[0])
                this.isAdd=true
            }
        },
        beforeUpload(file) {
            const isImg = file.type.indexOf('image')!=-1;
            const isSize = file.size / 1024 < 500;
            if (!isImg) {
                this.$message.error('请选择图片');
            }
            if (!isSize) {
                this.$message.error('图片大小不能超过 500kb');
            }
            return isImg && isSize;
        },
        uploadError(){
            this.$message.success('图片上传失败');
        },
        uploadSuccess(e){
            if(e.httpCode == 200){
                // this.$message.success('图片上传成功');
                this.$set(this.form,this.uploadkey,e.data[0].wwwurl);
            }else{
                this.$set(this.form,this.uploadkey,'');
                this.$message.error('图片上传失败');
            }
            // this.$refs.upload.clearFiles();
            // this.showUploadModel = false;

        },
        /**
         * Dialog确定操作
         * @param type 1=工具栏，2=底部导航
         */
        submitTools(type){
            let template={
                moduleCode:'',
                description:'',
                level:this.activeRightBox.level+1,
                isAdd:'',
                limitCount:'',
                effectPicture:'',
                extParams:'',
                orderNum:'',
                isDelete:1,
                // isSort:'',
                isModify:1,
                isAdded:'',
            }
            if(this.activeIcon>-1&&type===2){
                this.$set(this.form,'footerIcon',this.activeIcon)
            }
            if((type==1||type==2)&&this.isAdd){
                this.form.isCustom = 1;
            }
            let that=this
            this.$refs[`form${type}`].validate((res)=>{
                if(res){
                    let cell=Object.assign({},template,that.form)
                    that.addModule(that.isAdd?type:`edit-${type}`,cell)
                    this.navModalVisible=false
                    this.toolsModalVisible=false
                }else{
                    return false
                }
            })
        },
        save(type=1){
            let list=JSON.parse(JSON.stringify(this.list))
            list[this.activeFooterTab].children=[].concat(this.viewport)
            if(type===1){
                this.saveModule({
                    params:{
                        parentId:this.footerBar.id,
                        level:this.footerBar.level,
                        data:this.sortList(list)
                    }
                })
            }else{
                this.list=[].concat(JSON.parse(JSON.stringify(list)))
            }
        },
        /**
         * 模块列表递归排序
         * @param list
         * @returns {boolean|*}
         */
        sortList(list){
            if(list.length<1){
                return false
            }
            list.forEach((item,index)=>{
                item.orderNum=index+1
                if(!list[index].children){
                    return false
                }else{
                    return this.sortList(list[index].children)
                }
            })
            return list
        },
        // 是否超数量限制
        hasAddByCount(list,limitCount){
            if(limitCount && limitCount<=list.length){
                return true;
            }
            return false
        },
        // 是否已添加
        hasAddFn(id,list){
            let str=JSON.stringify(list);
            return str.includes(id);
        },
        // 是否可编辑
        hasEdit(level) {
            if(level==1){
                return this.footerBar.isEdit==1
            }
            if(level==2){
                return this.list[this.activeFooterTab]&&this.list[this.activeFooterTab].isEdit==1&&this.hasEdit(--level)
            }
        }
    },
    filters:{
        hasAdd(id,list,limitCount){
            console.log(limitCount)
            let str=JSON.stringify(list)
            if(limitCount){
                if(str.includes(id)||limitCount<=list.length){
                    console.log(list,id)
                    return true;
                }
                return false
            }else{
                return str.includes(id)
            }
        },
        hasAdd2(id,list){
            let str=JSON.stringify(list)
            return str.includes(id)
        },
        sysConfigText(val,type=1){
            if(type===1){
                return val?'已添加':'添加到工具栏'
            }else if(type===2){
                return val?'gray':''
            }else if(type===3){
                return val?'已添加':'添加到导航栏'
            }
        },
        settingImage(val){
            if(!val){
                return 'static/images/setting/app.png'
            }else{
                return val
            }
        },
        /**
         * 模块的extParams扩展字段控制标签元素的显示隐藏
         * @param val
         * @param type 1=编辑按钮
         * @returns {null}
         */
        filtterExtendParams(val,type=1){
            let result=null
            if(!val||val.length===0){
                result={display:'none'}
            }else{
                switch (type) {
                    case 1:
                        if(Number(val)===1){
                            result={display: 'inline'}
                        }else{
                            result={display:'none'}
                        }
                        break
                }
            }
            return result
        }
    },
};
</script>
<style lang="scss">
@import "./app.scss";
</style>
